import { render } from "./Overview.vue?vue&type=template&id=4ec7908e&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=4ec7908e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ec7908e"

export default script